<template>
  <div>
    <div class="d-flex justify-end">
      <v-btn class="d-flex align-center" variant="text" @click="downloadPf">
        <v-icon
          class="mr-2"
          size="large"
          icon="mdi-printer"
          style="margin-bottom: -2px"></v-icon>
        <span>Роздрукувати форму звіту</span>
      </v-btn>
    </div>
    <acknowledgment-list></acknowledgment-list>
  </div>
</template>

<script>
import { openDialog } from '@/dialog'
import { familiarizationListHeaders } from '@/utils/tableHeaders'
import AcknowledgmentList from '@/components/acknowledgment/AcknowledgmentList.vue'

export default {
  name: 'Familiarization',
  components: { AcknowledgmentList },
  data() {
    return { familiarizationListHeaders }
  },
  setup() {
    const downloadPf = () => {
      openDialog({
        name: 'FamiliarizationReport',
        action: 'create',
      })
    }

    return {
      downloadPf,
    }
  },
}
</script>
